'use strict';

export const PAGE_TITLE_BRAND = 'EcartPay Admin';
const PAGE_TITLE_SEPARATOR = ' · ';

export function buildPageTitle(...parts) {
    const segments = [];
    for (const part of parts) {
        if (part == null) {
            continue;
        }
        const text = String(part).trim();
        if (text === '') {
            continue;
        }
        segments.push(text);
    }
    return [...segments, PAGE_TITLE_BRAND].join(PAGE_TITLE_SEPARATOR);
}

export function setPageTitle(...parts) {
    document.title = buildPageTitle(...parts);
}

export function runWhenDocumentVisible(callback, doc = typeof document !== 'undefined' ? document : null) {
    if (!doc || doc.visibilityState === 'visible') {
        callback();
        return () => {};
    }

    let is_cancelled = false;

    const on_visible = () => {
        if (is_cancelled) {
            return;
        }
        if (doc.visibilityState !== 'visible') {
            return;
        }
        doc.removeEventListener('visibilitychange', on_visible);
        callback();
    };

    doc.addEventListener('visibilitychange', on_visible);

    return () => {
        is_cancelled = true;
        doc.removeEventListener('visibilitychange', on_visible);
    };
}
